<template>
  <main class="detail-ecoles">
    <div class>
      <div class="row">
        <div class="col-md-12 top-wrapper">
          <TopTemplate>
            <template v-slot:left-element>
              <router-link :to="{name: 'school_list'}" class="btn btn-outline-primary button">
                <i class="arrow left" />
                {{ $t("button.retour") }}
              </router-link>
            </template>

            <template v-slot:right-element>
              <div class="d-flex buttons-wrapper">
                <router-link :to="{name: 'EditSchool', params: {id: referenceId}}" class="btn button btn-primary">
                  <i class="icon-edit-02"> </i>
                  {{ $t("button.edit") }}
                </router-link>
              </div>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-if="!loading">
        <div class="row">
          <div class="col-md-12">
            <div class="coor-wrapper">
              <div class="part-left">
                <div v-if="reference.photo == null" class="avatar" />
                <div v-else class="avatar picture-info d-flex justify-content-center">
                  <img :src="reference.photo" alt="info student" />
                </div>
                <div class="name-wrapper">
                  <div class="full-name">
                    <span class="name" v-if="reference"> {{ reference.name }}</span>
                  </div>
                  <span class="birth" v-if="reference"> {{ reference.address }}<span v-if="reference.address">,</span> </span>
                  <p>
                    <span class="birth" v-if="reference"> {{ reference.zip_code }} {{ reference.governorate_name }} </span>
                  </p>
                </div>
              </div>

              <div class="part-right-detail-school">
                <div v-if="reference.phone_number" class="info-school">
                  <i class="icon-phone"></i><span>{{ reference.phone_number }}</span>
                </div>
                <div v-if="reference.email" class="info-school">
                  <i class="icon-mail"></i> <span>{{ reference.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top-part top" v-if="reference.school_admins && reference.school_admins.length > 0">
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper list-ecoles">
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ $t("school.admin") }}</th>
                      <th>{{ $t("school.addressMail") }}</th>
                      <th class="col-md-2">{{ $t("teacher.tab.status") }}</th>
                      <th>{{ $t("school.telephone") }}</th>
                      <th>{{ $t("common.actions") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in reference.school_admins" :key="index">
                      <td>
                        <span class="lastName_propre">{{ value.last_name }}&nbsp;</span><span class="name_propre">{{ value.first_name }}</span>
                      </td>
                      <td>
                        {{ value.email }}
                      </td>
                      <td class="col-md-2">
                        <p>
                          <span :class="statusClass(value)"> {{ statusText(value) }} </span>
                        </p>
                      </td>
                      <td>
                        {{ value.phone }}
                      </td>

                      <td>
                        <!-- bloc -->
                        <i class="icon-forbiden" @click.prevent="blocageAdminFn(value)">
                          <span class="tooltiptext">{{ $t("button.tooltip.blocage") }}</span>
                        </i>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="table__wrapper__pagination-wrapper">
                  <div class="pagination">
                    <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="container-fluid matiere-liste">
        <div class>
          <h3>{{ $t("title.listSchool") }}</h3>
          <div class="row items-wrapper">
            <div v-for="module in modules_list" :key="module.id" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer">
              <div class="matiere-item" :class="module.is_checked === true ? 'matiere-background' : ''">
                <span>{{ module.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="container-fluid matiere-liste niveau-liste">
        <div>
          <h3>{{ $t("title.niveauEtude") }}</h3>
          <div class="row items-wrapper">
            <div v-for="gategorie in gategories_list" :key="gategorie.id" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer">
              <div class="matiere-item" :class="{'matiere-background': selectedGat.includes(gategorie.id)}">
                <span>{{ gategorie.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>




<script>
import TopTemplate from "../../../components/toptemplate/TopTemplate.vue";
import SchoolService from "../../../services/school.service";
import {mapActions} from "vuex";

export default {
  name: "DetailsSchool",
  components: {
    TopTemplate,
  },
  data() {
    return {
      referenceId: null,
      reference: {},
      modules_list: [],
      gategories_list: [],
      selectedGat: [],
      last_page: null,
      loading: false,
      tuteur: {},
    };
  },
  created() {
    this.referenceId = this.$route.params.id;
  },

  computed: {
    statusClass() {
      return (admin) => {
        if (admin.admin_account_status == 1) {
          return "blocked_status";
        }
        return admin.status === 1 ? "active_status" : "noActive_status";
      };
    },

    statusText() {
      return (admin) => {
        if (admin.admin_account_status === 1) {
          return this.$t("common.blocked");
        } else if (admin.admin_account_status === 0 && admin.status === 1) {
          return this.$t("common.save");
        } else {
          return this.$t("common.noSave");
        }
      };
    },
  },

  mounted() {
    this.getDetails();
    this.getGategories();
  },

  methods: {
    getGategories(params) {
      this.loading = true;
      SchoolService.getAllGategories({
        params: {},
      })
        .then((response) => {
          this.gategories_list = response.data.data;
          this.gategories_list = _.orderBy(response.data.data, "name");
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    getDetails() {
      this.loading = true;
      SchoolService.getById(this.referenceId)
        .then((data) => {
          this.reference = data.data.data;
          this.modules_list = _.orderBy(this.reference.modules, "name");
          this.gategories_list_set = this.reference.school_categories;
          this.gategories_list_set.forEach((element) => {
            this.selectedGat.push(element.id);
          });
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions(["blocageAdmin"]),
    blocageAdminFn(admin) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });

      swalWithBootstrapButtons
        .fire({
          title: admin.admin_account_status === 0 || admin.admin_account_status === null ? this.$t("common.confirmBlockedAdmin") : this.$t("common.confirmDeblockedAdmin"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const params = {
              id: admin.id,
              payload: {
                status: admin.admin_account_status === 0 || admin.admin_account_status === null ? 1 : 0,
              },
            };

            this.blocageAdmin(params)
              .then(() => {
                admin.admin_account_status = admin.admin_account_status === 0 || admin.admin_account_status === null ? 1 : 0;

                swalWithBootstrapButtons.fire(admin.admin_account_status === 0 ? this.$t("common.adminDeblocked") : this.$t("common.adminBlocked"), "", "success");
              })
              .catch((error) => {
                this.loading = false;
              });
          }
        });
    },
  },
};
</script>
<style scoped>
.detail-ecoles .table__wrapper thead > tr > th {
  padding: 20px 5px;
  font-size: 12px;
}
.detail-ecoles i.icon-phone,
i.icon-mail {
  color: #34b9bb;
  font-size: 23px;
  position: relative;
  top: 5px;
}
.niveau-liste {
  margin-top: 20px;
}
</style>

